import type { RangeFormatter } from '../../types';

const formatter = new Intl.NumberFormat('en', {
  minimumFractionDigits: 0,
  useGrouping: true,
});

export const priceFormatter: RangeFormatter = (value) => {
  if (Array.isArray(value)) {
    return `${formatter.format(Number(value[0]))} - ${formatter.format(
      Number(value[1])
    )}`;
  }

  return '';
};

export default priceFormatter;
